<template>
	<div class="m-search">
		<c-form ref="form">
			<slot></slot>
			<m-search-item v-for="(item, i) in filterList" :key="i" :label="item.label" :colspan="item.type == 'time' ? 2 : 1">
				<template v-if="item.type == 'number'">
					<div class="flex-center">
						<c-input
							v-model="item.value[0]"
							class="flex-grow"
							type="number"
							:decimal="item.config.attr.includes('decimal') ? item.config.decimal : 0"
							:range="[-Infinity, item.value[1]]"
							placeholder="最小值"
						></c-input>
						<span style="min-width: 30px; text-align: center;">-</span>
						<c-input
							v-model="item.value[1]"
							class="flex-grow"
							type="number"
							:decimal="item.config.attr.includes('decimal') ? item.config.decimal : 0"
							:range="[item.value[0], Infinity]"
							placeholder="最大值"
						></c-input>
					</div>
				</template>
				<template v-else-if="item.type == 'time'">
					<c-datetime
						v-model="item.value"
						range
						:type="item.config.format.split('|')[1]"
						:format="item.config.format.split('|')[0]"
						:time-accuracy="item.config.format.split('|')[2]"
					></c-datetime>
				</template>
				<template v-else-if="item.type == 'option'">
					<c-checkbox-group v-model="item.value" :options="item.config.options"></c-checkbox-group>
				</template>
				<template v-else>
					<c-input v-model="item.value"></c-input>
				</template>
			</m-search-item>
		</c-form>
	</div>
</template>

<script>
	export default {
		name: 'mSearch',

		props: {
			defaultData: Object,
			initData: Object
		},

		data() {
			return {
				viewListHandle: false,
				filterList: []
			}
		},

		mounted() {
			if (this.defaultData || this.initData) {
				this._lastSearch = Object.assign({}, this.defaultData, this.initData);
				this.set(this._lastSearch);
			}

			let $parent = this.$parent.$parent;
			if ($parent.$options.name == 'topbar' && $parent.workType) {
				this.request({
					url: '/sys_user_view/filter_field_list',
					data: {
						work_type_id: $parent.workType,
						is_custom: 1
					},
					success: data => {
						this.filterList = data.map(item => {
							return {
								field: item.id,
								label: item.field_title,
								type: item.config_json.type,
								value: ['number', 'time'].includes(item.config_json.type) ? ['', ''] : item.config_json.type == 'option' ? [] : '',
								config: item.config_json
							}
						});
					}
				});
			}
		},
		
		methods: {
			search() {
				this._lastSearch = Object.assign(this.$refs.form.get(), {
					user_filter_condition: this.filterList.map(item => {
						return {
							field_id: item.field,
							query_operator: item.type == 'text' ? 'like' : item.type == 'option' ? 'in' : 'range',
							field_value: item.type == 'text' ? item.value.trim() : item.type == 'option' ? item.value : item.value.map(item => item || null)
						}
					}).filter(item => Array.isArray(item.field_value) ? item.field_value.filter(item => item).length : item.field_value)
				});
				this._lastSearchSelectData = {};
				this.$refs.form.eachUnit($item => {
					if ($item.$options.name == 'cSelect' && $item.async) {
						this._lastSearchSelectData[$item.name] = $item.multiple ? $item.getData() : [$item.getData()];
					}
				});
				if (this.viewListHandle) {
					this.viewListHandle(this.get());
				} else {
					this.$emit('search', this.get());
				}
			},
			
			set(data) {
				this.$refs.form.set(data);
				this.$nextTick(() => {
					data.user_filter_condition && data.user_filter_condition.forEach(item => {
						this.filterList.find(field => field.field == item.field_id).value = Array.isArray(item.field_value) ? item.field_value.map(item => item === null ? '' : item) : item.field_value;
					});
				});
			},
			
			get() {
				return this._lastSearch || {};
			},
			
			clear() {
				this.$refs.form.clear();
				if (this.defaultData) {
					this.set(this.defaultData);
				}
			},

			reset() {
				this.$refs.form.clear();
				this.set(this.get());
				this._lastSearchSelectData && this.$refs.form.eachUnit($item => {
					if (this._lastSearchSelectData[$item.name]) {
						$item.setValueData(this._lastSearchSelectData[$item.name]);
					}
				});
			}
		}
	}
</script>

<style lang="stylus">
	.m-search {
		.c-input,
		.c-select,
		.c-datetime {
			height: .72rem;
		}

		.c-select-tag {
			padding: .11rem 0;
		}
	}
</style>
